import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import i18next from 'i18next';
import { BOQ_STATUS } from '../boqStatus';
import {
  getBoqStatusNoticeIconSx,
  getBoqStatusNoticeSx,
  boqStatusNoticeTextSx,
  boqDiscardBarActionSx,
  boqUnsavedBarActionsSx,
  boqSaveButtonSx,
} from './style';

const StatusIcon = ({ status, unsaved = false }) => {
  const iconSx = getBoqStatusNoticeIconSx(status.tone);
  if (unsaved) {
    return <ReplayIcon sx={iconSx} aria-hidden />;
  }
  if (status.value === BOQ_STATUS.DRAFT) {
    return <EditOutlinedIcon sx={iconSx} aria-hidden />;
  }
  if (status.value === BOQ_STATUS.PUBLISHED_SENT) {
    return <CheckCircleIcon sx={iconSx} aria-hidden />;
  }
  return <LockOutlinedIcon sx={iconSx} aria-hidden />;
};

const BoqStatusNotice = ({
  status,
  showDiscard = false,
  discardDisabled = false,
  onDiscard = () => null,
  onSaveDraft = () => null,
}) => {
  if (!status?.noticeKey) return null;
  const noticeKey = showDiscard
    ? 'boq-unsaved-changes-notice'
    : status.noticeKey;
  return (
    <Box
      data-testid="boq-status-notice"
      sx={getBoqStatusNoticeSx(status.tone, { sticky: showDiscard })}
    >
      <StatusIcon status={status} unsaved={showDiscard} />
      <Typography sx={boqStatusNoticeTextSx}>{i18next.t(noticeKey)}</Typography>
      {showDiscard && (
        <Box sx={boqUnsavedBarActionsSx}>
          <Button
            variant="text"
            disabled={discardDisabled}
            onClick={onDiscard}
            aria-label={i18next.t('boq-discard-draft')}
            data-testid="boq-discard-draft"
            sx={boqDiscardBarActionSx}
          >
            {i18next.t('boq-discard-draft')}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            disabled={discardDisabled}
            onClick={onSaveDraft}
            data-testid="boq-save-draft"
            sx={boqSaveButtonSx}
          >
            {i18next.t('boq-save-draft')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default BoqStatusNotice;
